import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box } from '@mui/material';
import './ProductCard.css';
import defaultImage from '../img/no-product.png';

function ProductCard({ product }) {  // product prop is accepted here
  const maxTitleLength = 20;
  const displayTitle = product.name.length > maxTitleLength ? product.name.substring(0, maxTitleLength) + '...' : product.name;
  

  const handleError = (event) => {
    event.target.src = defaultImage;
  }


  return (
    <Box sx={{ width: 220, height: '400px', maxHeight: '400px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
      <Card className="productCard" sx={{ backgroundColor: '#1d4ed8', borderRadius: '15px', boxShadow: '0 0 10px 1px rgb(72 112 223)'}}>
       <CardMedia
          component="img"
          height="140"
          image={product.image}
          alt={product.name}
          onError={handleError}
        />
        <CardContent style={{backgroundColor: 'rgb(72 112 223)', color: 'white'}}>
          <Typography gutterBottom variant="h5" component="div" sx={{fontSize: '16px', fontWeight: 'bold'}}>
            {displayTitle}
          </Typography>
          <Typography className="description" variant="body2" color="white">
            {product.description}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'baseline', mt: 1 }}>
            <Typography variant="h6">
              ${product.price}
            </Typography>
            <Typography variant="h6" sx={{ textDecoration: 'line-through', fontSize: '16px', ml: 1 }}>
              ${product.compareAtPrice}
            </Typography>
          </Box>
         
          <Box sx={{ display: 'flex', alignItems: 'baseline', mt: 1 }}>
            <Typography variant="h6" sx={{ fontSize: '16px' }}>
              In stock : {product.inventoryQuantity}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default ProductCard;
